export default {
  newsList: [],
  allNews: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  loading: false,
  // Public news for home page
  allPublicNews: [],
  publicNews: [],
  publicNewsPagination: {
    current: 1,
    pageSize: 3,
    total: 0,
  },
  publicNewsLoading: false,
}

